// Configuration for Leads Workspace

export const LEAD_STATUS_CONFIG = {
  New: { color: "#3b82f6", bg: "#eff6ff", border: "#bfdbfe" },
  Connected: { color: "#10b981", bg: "#ecfdf5", border: "#a7f3d0" },
  Interested: { color: "#8b5cf6", bg: "#f5f3ff", border: "#ddd6fe" },
  Followups: { color: "#f59e0b", bg: "#fffbeb", border: "#fde68a" },
  "Follow Up": { color: "#f59e0b", bg: "#fffbeb", border: "#fde68a" },
  "Not Connected": { color: "#ef4444", bg: "#fef2f2", border: "#fecaca" },
  "Not Interested": { color: "#64748b", bg: "#f8fafc", border: "#e2e8f0" },
  Converted: { color: "#059669", bg: "#d1fae5", border: "#6ee7b7" },
  Invalid: { color: "#dc2626", bg: "#fee2e2", border: "#fca5a5" },
  Onboarded: { color: "#059669", bg: "#d1fae5", border: "#6ee7b7" },
};

export const AVAILABLE_STATUSES = ["New", "Connected", "Interested", "Follow Up", "Followups", "Not Connected", "Not Interested", "Converted", "Invalid", "Onboarded"];

export const PRODUCT_REMARKS_CONFIG = ["ISO 9001:2015 Certified", "MSME Registered Enterprise", "SOC2 Type II Compliant", "HIPAA Compliant", "GDPR Ready"];

export const INITIAL_COMPANIES = [];
